import React, { useEffect, useState } from "react";
import { AiOutlineMinus, AiOutlinePlus } from "react-icons/ai";
import {
  FaFacebook,
  FaInstagram,
  FaWhatsapp,
  FaPinterest,
  FaGoogle,
  FaRegSmile,
  FaYoutube,
} from "react-icons/fa";
import { SiThreads } from "react-icons/si";
import { ToastContainer, toast } from "react-toastify";
import { FaXTwitter } from "react-icons/fa6";
import { PartyPopper, X } from "lucide-react";
import "react-toastify/dist/ReactToastify.css";
import logo from "../Assets/lo.png";
import Footer from "./Footer";
import { createPackage } from "../api/api";
import { AiOutlineDelete } from "react-icons/ai";
import OurClients from "./OurClients";
import LineChartComponent from "./LineChartComponent";
// import google from "../Assets/business_324097.png"
import Loader from "../Loader/Loader";
const PRICING = {
  poster: 500,
  video: { "15s": 750, "30s": 1250, "60s": 1750 },
  influencer: 3000,
  review: 50,
  platform: 1000,
};

const Home = () => {
  const [posterQuantity, setPosterQuantity] = useState(0);
  const [videoQuantity, setVideoQuantity] = useState(0);
  const [influencerQuantity, setInfluencerQuantity] = useState(0);
  const [reviewQuantity, setReviewQuantity] = useState(0);
  const [metaAdsAmount, setMetaAdsAmount] = useState("");
  const [googleAdsAmount, setGoogleAdsAmount] = useState("");
  const [youtubeAdsAmount, setYoutubeAdsAmount] = useState("");
  const [animationTime, setAnimationTime] = useState("15s");
  const [selectedPlatforms, setSelectedPlatforms] = useState([]);
  const [errors, setErrors] = useState({ meta: "", google: "", youtube: "" });
  const [isOpen, setIsOpen] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [savingsAmount, setSavingsAmount] = useState(0);
  const [valueAmount, setValueAmount] = useState(0);
  const [valueTwoAmount, setValueTwoAmount] = useState(0);
  const [valueThreeAmount, setValueThreeAmount] = useState(0);
  
  const [gst, setGst] = useState(0);
  const [cgst, setCgst] = useState(0);



  const [metaAdsReach, setMetaAdsReach] = useState({ min: 0, max: 0 });
  const [isLoading, setIsLoading] = useState(false);
  const [userData, setUserData] = useState({
    name: "",
    businessName: "",
    email: "",
    mobile: "",
    message: "",
    gstNo: "",
    landline: "",
    state: "",
    city: "",
    pincode: "",
    address: "",
  });
  const calculateTaxes = (discountedTotal) => {
    const calculatedGst = discountedTotal * 0.09; // 9% GST
    const calculatedCgst = discountedTotal * 0.09; // 9% CGST
    return { calculatedGst, calculatedCgst };
  };

  const removeItem = (item) => {
    switch (item) {
      case "poster":
        setPosterQuantity(0);
        break;
      case "video":
        setVideoQuantity(0);
        break;
      case "influencer":
        setInfluencerQuantity(0);
        break;
      case "review":
        setReviewQuantity(0);
        break;
      case "metaAds":
        setMetaAdsAmount("");
        break;
      case "googleAds":
        setGoogleAdsAmount("");
        break;
      case "youtubeAds":
        setYoutubeAdsAmount("");
        break;
      case "publishing":
        setSelectedPlatforms("");
        break;
      default:
        break;
    }
  };

  const handleQuantityChange = (setter, value, min, max) => {
    setter(Math.min(Math.max(value, min), max));
  };

  const togglePlatformSelection = (platform) => {
    setSelectedPlatforms((prev) =>
      prev.includes(platform)
        ? prev.filter((p) => p !== platform)
        : [...prev, platform]
    );
  };

  const calculateCosts = () => {
    const animatedVideoCost =
      videoQuantity > 0 ? PRICING.video[animationTime] * videoQuantity : 0;
    const socialMediaPosterCost = posterQuantity * PRICING.poster;
    const influencerAdsCost = influencerQuantity * PRICING.influencer;
    const googleReviewCost = reviewQuantity * PRICING.review;
    const metaAdsCost = metaAdsAmount >= 1000 ? metaAdsAmount * 1.3 : 0;
    const googleAdsCost = googleAdsAmount >= 1000 ? googleAdsAmount * 1.3 : 0;
    const youtubeAdsCost =
      youtubeAdsAmount >= 1000 ? youtubeAdsAmount * 1.3 : 0;
    const publishingCost = selectedPlatforms.length * PRICING.platform;

    const total =
      socialMediaPosterCost +
      animatedVideoCost +
      influencerAdsCost +
      googleReviewCost +
      metaAdsCost +
      googleAdsCost +
      youtubeAdsCost +
      publishingCost;
    // const cgst = total * 0.09; // 9% of total
    // const gst = total * 0.09; // 9% of total

    return {
      total,
      // cgst,
      // gst,
      metaAdsCost,
      googleAdsCost,
      youtubeAdsCost,
      publishingCost,
    };
  };

  const {
    total,
    
    metaAdsCost,
    googleAdsCost,
    youtubeAdsCost,
    publishingCost,
  } = calculateCosts();

  const calculateMetaAdsReach = (amount) => {
    if (amount >= 1000) {
      const reach = Math.floor((amount / 1000) * 3000); // Minimum reach
      const maxReach = Math.floor((amount / 1000) * 5000); // Maximum reach
      return { min: reach, max: maxReach };
    }
    return { min: 0, max: 0 };
  };
  const handleAdsChange = (setter, value, type) => {
    const parsedValue = parseInt(value);
    if (type === "meta") {
      const { min, max } = calculateMetaAdsReach(parsedValue);
      setMetaAdsReach({ min, max });
    }
    if (parsedValue < 1000) {
      setErrors((prev) => ({ ...prev, [type]: "Minimum amount is ₹1000" }));
      setter(parsedValue);
    } else {
      setErrors((prev) => ({ ...prev, [type]: "" }));
      setter(parsedValue);
    }
  };

  const handleUserDataChange = (e) => {
    const { name, value } = e.target;
    setUserData((prev) => ({ ...prev, [name]: value }));
  };

  const handleBuyNow = async () => {
    // Check if all required user data fields are filled
    const requiredFields = ["name", "businessName", "email", "mobile","gstNo"];
    const missingFields = requiredFields.filter(
      (field) => !userData[field].trim()
    );
  
    if (missingFields.length > 0) {
      toast.warn(
        `Please fill in the following fields: ${missingFields.join(", ")}`
      );
      return;
    }
  
    // Check if a plan is selected
    if (!selectedOption) {
      toast.warn("Please select a plan before proceeding to buy.");
      return;
    }
  
    const discountedPrice = calculateDiscountedPrice();
    const formattedDiscountedPrice = discountedPrice
      ? discountedPrice.toFixed(2)
      : "0.00";
      const sgst = (calculateDiscountedPrice() / 1.18) * (9 / 100);
      const cgst = (calculateDiscountedPrice() / 1.18) * (9 / 100);
      const afterdiscount=(calculateDiscountedPrice() - ((calculateDiscountedPrice() / 1.18) * (9 / 100) * 2)).toFixed(2)
  
    const overallTotal = (total + cgst + gst).toFixed(2);
  const metaReach = calculateReach(metaAdsAmount);
  const googleReach = calculateGoogleReach(googleAdsAmount);
  const youtubeReach = calculateYoutubeReach(youtubeAdsAmount);
    const orderDetails = {
      posterQuantity: posterQuantity || 0,
      videoQuantity: videoQuantity || 0,
      influencerQuantity: influencerQuantity || 0,
      reviewQuantity: reviewQuantity || 0,
      metaAdsCost: Number(metaAdsCost) || 0,
      googleAdsCost: Number(googleAdsCost) || 0,
      youtubeAdsCost: Number(youtubeAdsCost) || 0,
      animationTime: Number(animationTime) || 0,
      publishingCost: Number(publishingCost) || 0,

      selectedPlatforms: selectedPlatforms.length ? selectedPlatforms : [],
      totalCost: total || 0,
      discountedPrice: parseFloat(formattedDiscountedPrice),
      overallTotal: parseFloat(overallTotal),
      // New amounts
      beforeQuartlyDiscount:valueAmount,
      beforeHalfDiscount:valueTwoAmount,
      beforeAnnualDiscount:valueThreeAmount,



      posterAmount: posterQuantity * PRICING.poster,
      videoAmount:
        videoQuantity > 0 ? PRICING.video[animationTime] * videoQuantity : 0,
      influencerAmount: influencerQuantity * PRICING.influencer,
      reviewAmount: reviewQuantity * PRICING.review,
      // New fields for discounts and taxes
      selectedPlan: selectedOption.label, // e.g., "Quarterly", "Half-Yearly", "Annual"
      discountAmount: savingsAmount, // Assuming you have calculated this already
      cgst:cgst , // CGST amount
      gst:sgst, 
      afterdiscount:afterdiscount, // After discount amount
      influencerDuration: animationTime, // GST amount
      metaAdsReachMin: metaReach.min, 
      metaAdsReachMax: metaReach.max, 
      googleAdsReachMin: googleReach.min, 
      googleAdsReachMax: googleReach.max, 
      youtubeAdsReachMin: youtubeReach.min, 
      youtubeAdsReachMax: youtubeReach.max, // Add publishing cost here
    };
  
    const userDataPayload = {
      name: userData.name?.trim() || "",
      email: userData.email?.trim() || "",
      mobile: userData.mobile?.trim() || "",
      businessName: userData.businessName?.trim() || "",
      message: userData.message,
      gstNo: userData.gstNo?.trim() || "",
      landline: userData.landline?.trim() || "",
      state: userData.state?.trim() || "",
      city: userData.city?.trim() || "",
      pincode: userData.pincode?.trim() || "",
      address: userData.address?.trim() || "",
    };
  
    console.log("Sending Order:", orderDetails);
    console.log("Sending User Data:", userDataPayload);
    setIsLoading(true);
    try {
      const response = await createPackage({
        orderDetails,
        userData: userDataPayload,
      });
  
      if (response?.success) {
        toast.success("Order submitted successfully!");
        resetForm?.(); // Ensure resetForm exists before calling
      } else {
        toast.error(response?.message || "Failed to submit order. Try again.");
      }
    } catch (error) {
      console.error("API Error:", error.response?.data || error.message);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const resetForm = () => {
    setPosterQuantity(0);
    setVideoQuantity(0);
    setInfluencerQuantity(0);
    setReviewQuantity(0);
    setMetaAdsAmount("");
    setGoogleAdsAmount("");
    setYoutubeAdsAmount("");
    setAnimationTime("15s");
    setSelectedPlatforms([]);
    setSelectedOption([]);
    setUserData({
      name: "",
      businessName: "",
      email: "",
      mobile: "",
      message: "",
      gstNo: "",
      landline: "",
      state: "",
      city: "",
      pincode: "",
      address: "",
    });
  };
  // const chartData = [
  //   { name: "Posters", total: posterQuantity * PRICING.poster },
  //   {
  //     name: "Videos",
  //     total:
  //       videoQuantity > 0 ? PRICING.video[animationTime] * videoQuantity : 0,
  //   },
  //   { name: "Influencer", total: influencerQuantity * PRICING.influencer },
  //   { name: "Reviews", total: reviewQuantity * PRICING.review },
  //   { name: "Meta Ads", total: metaAdsCost },
  //   { name: "Google Ads", total: googleAdsCost },
  //   { name: "YouTube Ads", total: youtubeAdsCost },
  //   { name: "Publishing", total: publishingCost },
  //   { name: "Total", total: total },
  // ];
  const options = [
    { label: "Quarterly", discount: 5 },
    { label: "Half-Yearly", discount: 10 },
    { label: "Annual", discount: 15 },
  ];
  const [selectedOption, setSelectedOption] = useState(null);

  const handleSelect = (option) => {
    setSelectedOption(option);
    if (option.label === "Quarterly") {
      const overallTotal = (total).toFixed(2);
      const discountAmount = (overallTotal * option.discount * 3 ) / 100;
       const valueAmount=(overallTotal * 3);
       setValueAmount(valueAmount)
     // Calculate the discount amount
      setSavingsAmount(discountAmount); // Set the savings amount
      setIsDialogOpen(true); // Open dialog when Quarterly is selected
    }
    if (option.label === "Half-Yearly") {
      const overallTotal = (total ).toFixed(2);
      const discountAmount = (overallTotal * option.discount * 6) / 100;
      const valueTwoAmount=(overallTotal * 6);
      setValueTwoAmount(valueTwoAmount) // Calculate the discount amount
      setSavingsAmount(discountAmount); // Set the savings amount
      setIsDialogOpen(true); // Open dialog when Quarterly is selected
    }
    if (option.label === "Annual") {
      const overallTotal = (total ).toFixed(2);
      const discountAmount = (overallTotal * option.discount * 12) / 100;
      const valueThreeAmount=(overallTotal * 12);
      setValueThreeAmount(valueThreeAmount)
      // Calculate the disco  unt amount
      setSavingsAmount(discountAmount); // Set the savings amount
      setIsDialogOpen(true); // Open dialog when Quarterly is selected
    }
  };
  const calculateReach = (amount) => {
    if (amount >= 1000) {
      const minReach = Math.floor((amount / 1000) * 3000);
      const maxReach = Math.floor((amount / 1000) * 5000);
      return { min: minReach, max: maxReach };
    }
    return { min: 0, max: 0 };
  };
  const calculateGoogleReach = (amount) => {
    if (amount >= 1000) {
      const minReach = Math.floor((amount / 1000) * 20);
      const maxReach = Math.floor((amount / 1000) * 50);
      return { min: minReach, max: maxReach };
    }
    return { min: 0, max: 0 };
  };
  const calculateYoutubeReach = (amount) => {
    if (amount >= 1000) {
      const minReach = Math.floor((amount / 1000) * 3000);
      const maxReach = Math.floor((amount / 1000) * 6000);
      return { min: minReach, max: maxReach };
    }
    return { min: 0, max: 0 };
  };
  const calculateDiscountedPrice = () => {
    const overallTotal = total; // Use the total without GST and CGST

    if (!selectedOption) return overallTotal; 

    const discountAmount = (overallTotal * selectedOption.discount) / 100; 
    const discountedTotal = overallTotal - discountAmount; // Subtract the discount from the total

    // Calculate GST and CGST
    const { calculatedGst, calculatedCgst } = calculateTaxes(discountedTotal);

    // Calculate the final total including GST and CGST
    const finalTotal = discountedTotal + calculatedGst + calculatedCgst;

    // Multiply the final total by the number of months based on the selected plan
    switch (selectedOption.label) {
      case "Quarterly":
        return finalTotal * 3; 
      case "Half-Yearly":
        return finalTotal * 6; 
      case "Annual":
        return finalTotal * 12; 
      default:
        return finalTotal; 
    }
  };

  // Update GST and CGST whenever the total or selected option changes
  useEffect(() => {
    if (total > 0 && selectedOption) {
      const overallTotal = total; // Use the total without GST and CGST
      const discountAmount = (overallTotal * selectedOption.discount) / 100; 
      const discountedTotal = overallTotal - discountAmount; // Subtract the discount from the total

      const { calculatedGst, calculatedCgst } = calculateTaxes(discountedTotal);
      setGst(calculatedGst);
      setCgst(calculatedCgst);
    }
  }, [total, selectedOption]);
  return (
    <>
      <div className="p-4 bg-gradient-to-br from-[#202020] via-[#181818] to-[#191919] text-white">
        <div className="flex flex-wrap max-w-screen-xl justify-between mx-auto">
          <div className="flex flex-col">
            <div className="    md:ml-0 ml-16  flex-col justify-center items-center  md:hidden flex ">
              <img src={logo} alt="logo" className="h-24 w-56 object-contain" />
              
            </div>
         <div className="flex flex-col justify-center items-center text-center">
         <h1 className="md:text-5xl text-2xl md:ml-0 ml-14 text-center pt-4 pb-3 font-bold bg-gradient-to-r from-[#00DE6D] to-[#00ACDC] bg-clip-text text-transparent">
              Essential Packages
            </h1>
         </div>
         
 
           
          </div>
        
          <div className="md:ml-0 ml-14 md:flex hidden">
            <img src={logo} alt="logo" className="h-24 w-56 object-contain" />
          </div>
        </div>

        <div className="flex justify-center">
          <ToastContainer />
          <div className="flex flex-col lg:flex-row w-full max-w-screen-xl gap-8">
            {/* Left Section - Redesigned with Cards */}
            <div className="w-full lg:w-1/2 ">
            <h2 className="md:text-xl text-sm md:text-start text-center font-semibold pb-2 p-1   ml-14  flex md:hidden  ">
            GSTIN: 33HOLPS4408LIZE
          </h2>
            <h2 className="md:text-xl text-sm md:text-start text-center font-semibold pb-2 p-1">
              Design your package your way.
            </h2> 
              <div className="grid grid-cols-1 md:grid-cols-1 gap-6">
                {[
                  {
                    label: "Social Media Poster",
                    quantity: posterQuantity,
                    setter: setPosterQuantity,
                    min: 0,
                    max: 100,
                    isAd: false,
                  },
                  {
                    label: "Animated Video",
                    quantity: videoQuantity,
                    setter: setVideoQuantity,
                    min: 0,
                    max: 100,
                    isAd: false,
                  },
                  {
                    label: "Social Media Influencer",
                    quantity: influencerQuantity,
                    setter: setInfluencerQuantity,
                    min: 0,
                    max: 100,
                    isAd: false,
                  },
                  {
                    label: "Google Reviews",
                    quantity: reviewQuantity,
                    setter: setReviewQuantity,
                    min: 0,
                    max: 100,
                    isAd: false,
                  },
                  {
                    label: "Meta Ads",
                    amount: metaAdsAmount,
                    setter: setMetaAdsAmount,
                    isAd: true,
                  },
                  {
                    label: "Google Ads",
                    amount: googleAdsAmount,
                    setter: setGoogleAdsAmount,
                    isAd: true,
                  },
                  {
                    label: "YouTube Ads",
                    amount: youtubeAdsAmount,
                    setter: setYoutubeAdsAmount,
                    isAd: true,
                  },
                ].map((item, index) => (
                  <div
                    key={index}
                    className="bg-white bg-opacity-10 backdrop-blur-md shadow-xl p-6 rounded-2xl border border-white border-opacity-20 space-y-4"
                  >
                    {/* Header Section */}
                    
                    <div className="flex flex-col md:flex-row items-start md:items-center justify-between border-b pb-2">
                      <div className="text-lg font-semibold md:flex items-center justify-between space-x-3">
                        <span>{item.label} </span>
                        <span className="text-sm text-gray-300">
                          {" "}
                          / (Per Month)
                        </span>
                        <span>
                          {errors[
                            item.label.toLowerCase().replace(" ", "")
                          ] && (
                            <span className="text-red-500 text-sm">
                              {
                                errors[
                                  item.label.toLowerCase().replace(" ", "")
                                ]
                              }
                            </span>
                          )}
                        </span>
                        <span>
                          {item.label === "Meta Ads" &&
                            metaAdsAmount >= 1000 && (
                              <p className="text-[#00DE6D] font-medium text-sm">
                                Approximate Reach:{" "}
                                {Math.floor((metaAdsAmount / 1000) * 3000)} to{" "}
                                {Math.floor((metaAdsAmount / 1000) * 5000)}{" "}
                                users
                              </p>
                            )}
                          {item.label === "Google Ads" &&
                            googleAdsAmount >= 1000 && (
                              <p className="text-[#00DE6D] font-medium text-sm">
                                Approximate Clicks :{" "}
                                {Math.floor((googleAdsAmount / 1000) * 20)} to{" "}
                                {Math.floor((googleAdsAmount / 1000) * 50)}{" "}
                                users
                              </p>  
                            )}
                          {item.label === "YouTube Ads" &&
                            youtubeAdsAmount >= 1000 && (
                              <p className="text-[#00DE6D] font-medium text-sm">
                                Approximate Views:{" "}
                                {Math.floor((youtubeAdsAmount / 1000) * 3000)}{" "}
                                to{" "}
                                {Math.floor((youtubeAdsAmount / 1000) * 6000)}{" "}
                                users
                              </p>
                            )}
                        </span>
                      </div>
                    </div>

                    {/* Ads Approximate Reach */}

                    {/* Ads Input Section */}
                    {item.isAd ? (
                      <div className="flex flex-col md:flex-row md:items-center md:space-x-4 space-y-4 md:space-y-0">
                        <input
                          type="number"
                          value={
                            item.label === "Meta Ads"
                              ? metaAdsAmount
                              : item.label === "Google Ads"
                              ? googleAdsAmount
                              : youtubeAdsAmount
                          }
                          onChange={(e) =>
                            handleAdsChange(
                              item.setter,
                              e.target.value,
                              item.label.toLowerCase().replace(" ", "")
                            )
                          }
                          className="w-32 text-center text-black bg-white rounded-md shadow-md p-2"
                          min="1000"
                          placeholder="Enter amount"
                        />

                        <span className="text-white">+ 30% Maintenance</span>
                      </div>
                    ) : (
                      <>
                        <QuantitySelector
                          quantity={item.quantity}
                          onChange={(value) =>
                            handleQuantityChange(
                              item.setter,
                              value,
                              item.min,
                              item.max
                            )
                          }
                          min={item.min}
                          max={item.max}
                        />
                        {item.label === "Animated Video" &&
                          videoQuantity > 0 && (
                            <DurationSelector
                              selected={animationTime}
                              onSelect={setAnimationTime}
                            />
                          )}
                      </>
                    )}
                  </div>
                ))}
              </div>
              <div className="bg-white bg-opacity-10 backdrop-blur-md shadow-xl p-8 rounded-2xl border border-white border-opacity-20 mt-4">
                <h2 className="md:text-lg  text-md font-semibold  border-b p-2">
                  Select Social Media Platforms Maintenance /
                  <span className=" text-sm">(Per Month)</span>{" "}
                </h2>
                <SocialMediaSelector
                  selected={selectedPlatforms}
                  onSelect={togglePlatformSelection}
                />
              </div>
            </div>

            {/* Right Section - Pricing Details */}
            <div className="w-full lg:w-[50%]  static">
            <h1 className="md:text-xl text-sm md:text-start text-center font-semibold pb-2 p-1 md:flex hidden  ">
            GSTIN: 33HOLPS4408LIZE
          </h1>
              <div>
                <form className="bg-white bg-opacity-10 backdrop-blur-md shadow-xl p-8 rounded-2xl border border-white border-opacity-20 mb-4 text-black">
                  <h2 className="text-lg text-white font-semibold border-b mb-4">
                    User Information
                  </h2>
                  <div className="grid md:grid-cols-2 grid-cols-1 gap-4">
                    <input
                      type="text"
                      name="name"
                      placeholder="Name *"
                      value={userData.name}
                      onChange={handleUserDataChange}
                      className="w-full bg-black bg-opacity-10 border outline-none text-white p-2 rounded-md"
                      required
                    />
                    <input
                      type="text"
                      name="businessName"
                      placeholder="Business Name *"
                      value={userData.businessName}
                      onChange={handleUserDataChange}
                      className="w-full bg-black bg-opacity-10 border outline-none text-white p-2 rounded-md"
                      required
                    />
                    <input
                      type="text"
                      name="gstNo"
                      placeholder="GST Number * "
                      value={userData.gstNo}
                      onChange={handleUserDataChange}
                      className="w-full bg-black bg-opacity-10 border outline-none text-white p-2 rounded-md"
                    />

                    <input
                      type="email"
                      name="email"
                      placeholder="Email *"
                      value={userData.email}
                      onChange={handleUserDataChange}
                      className="w-full bg-black bg-opacity-10 border outline-none text-white p-2 rounded-md"
                      required
                    />

                    <input
                      type="tel"
                      name="mobile"
                      placeholder="Mobile Number *"
                      value={userData.mobile}
                      onChange={handleUserDataChange}
                      className="w-full bg-black bg-opacity-10 border outline-none text-white p-2 rounded-md"
                      required
                    />
                    <input
                      type="tel"
                      name="landline"
                      placeholder="Landline Number"
                      value={userData.landline}
                      onChange={handleUserDataChange}
                      className="w-full bg-black bg-opacity-10 border outline-none text-white p-2 rounded-md"
                    />
                    <input
                      type="text"
                      name="state"
                      placeholder="State"
                      value={userData.state}
                      onChange={handleUserDataChange}
                      className="w-full bg-black bg-opacity-10 border outline-none text-white p-2 rounded-md"
                    />
                    <input
                      type="text"
                      name="city"
                      placeholder="City"
                      value={userData.city}
                      onChange={handleUserDataChange}
                      className="w-full bg-black bg-opacity-10 border outline-none text-white p-2 rounded-md"
                    />
                    <input
                      type="text"
                      name="pincode"
                      placeholder="Pincode"
                      value={userData.pincode}
                      onChange={handleUserDataChange}
                      className="w-full bg-black bg-opacity-10 border outline-none text-white p-2 rounded-md"
                    />
                    <textarea
                      name="address"
                      placeholder="Address"
                      value={userData.address}
                      onChange={handleUserDataChange}
                      className="w-full bg-black bg-opacity-10 border outline-none text-white p-2 rounded-md"
                    />
                  </div>
                  <textarea
                    name="message"
                    placeholder="Message"
                    value={userData.message}
                    onChange={handleUserDataChange}
                    className="w-full bg-black bg-opacity-10 mt-4 border outline-none text-white p-2 rounded-md"
                    required
                  />
                </form>
              </div>

              <div
                className={`bg-white bg-opacity-10 backdrop-blur-lg ${
                  total > 0 ? "h-auto" : "h-[90vh]"
                } shadow-2xl p-4 rounded-3xl text-center border border-white border-opacity-30 w-full max-w-4xl mx-auto`}
              >
                <h2 className="text-lg border-b font-semibold text-left text-white tracking-wide mb-5">
                  Price Details / <span className="text-sm">(Per Month)</span>
                </h2>

                <div className="overflow-x-auto">
                  <table className="w-full text-left text-md text-white">
                    <thead>
                      <tr className="border-b border-gray-500 font-semibold bg-white bg-opacity-10">
                        <th className="p-2">Item</th>
                        <th className="p-2">Quantity</th>
                        <th className="p-2">Amount</th>
                        <th className="p-2">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {total > 0 ? (
                        <>
                          {/* Map through pricing rows dynamically */}
                          {/* Add your PricingRow components here */}
                          {posterQuantity > 0 && (
                            <PricingRow
                              label="Social Media Poster"
                              quantity={posterQuantity}
                              cost={posterQuantity * PRICING.poster}
                              onRemove={() => removeItem("poster")}
                            />
                          )}
                          {videoQuantity > 0 && (
                            <PricingRow
                              label={`Animated Video (${animationTime})`}
                              quantity={videoQuantity}
                              cost={
                                videoQuantity * PRICING.video[animationTime]
                              }
                              onRemove={() => removeItem("video")}
                            />
                          )}
                          {influencerQuantity > 0 && (
                            <PricingRow
                              label="Influencer Ads (1 min)"
                              quantity={influencerQuantity}
                              cost={influencerQuantity * PRICING.influencer}
                              onRemove={() => removeItem("influencer")}
                            />
                          )}
                          {reviewQuantity > 0 && (
                            <PricingRow
                              label="Google Reviews"
                              quantity={reviewQuantity}
                              cost={reviewQuantity * PRICING.review}
                              onRemove={() => removeItem("review")}
                            />
                          )}
                          {metaAdsAmount >= 1000 && (
                            <PricingRow
                              label="Meta Ads + 30% Maintenance Charge"
                              quantity={0}
                              cost={metaAdsCost}
                              onRemove={() => removeItem("metaAds")}
                            />
                          )}
                          {googleAdsAmount >= 1000 && (
                            <PricingRow
                              label="Google Ads + 30% Maintenance Charge"
                              quantity={0}
                              cost={googleAdsCost}
                              onRemove={() => removeItem("googleAds")}
                            />
                          )}
                          {youtubeAdsAmount >= 1000 && (
                            <PricingRow
                              label="YouTube Ads + 30% Maintenance Charge"
                              quantity={0}
                              cost={youtubeAdsCost}
                              onRemove={() => removeItem("youtubeAds")}
                            />
                          )}
                          {selectedPlatforms.length > 0 && (
                            <PricingRow
                              label="Publishing Charges"
                              quantity={selectedPlatforms.length}
                              cost={publishingCost}
                              onRemove={() => removeItem("publishing")}
                            />
                          )}
                          <tr className="border-t-2 border-gray-400 font-bold text-md md:text-lg text-white">
                            <td className="p-4">Monthly Total</td>
                            <td className="p-4"></td>
                            <td className="p-4">₹{total.toFixed(2)}</td>
                          </tr>
                          {/* <tr className="border-t-2 border-gray-400 font-medium text-md text-white">
                            <td className="p-4">CGST (9%)</td>
                            <td className="p-4"></td>
                            <td className="p-4">₹{cgst}</td>
                          </tr>
                          <tr className="border-t-2 border-gray-400 font-medium text-md text-white">
                            <td className="p-4">GST (9%)</td>
                            <td className="p-4"></td>
                            <td className="p-4">₹{gst}</td>
                          </tr> */}
                          {/* <tr className="border-t-2 border-gray-400 font-bold text-lg text-white">
                            <td className="p-4">Overall Total</td>
                            <td className="p-4"></td>
                            <td className="p-4">
                              ₹{(total ).toFixed(2)}
                            </td>
                          </tr> */}
                          <DiscountDialog
                            isOpen={isDialogOpen}
                            onClose={() => setIsDialogOpen(false)}
                            savings={savingsAmount}
                            selectedPlan={selectedOption ? selectedOption.label : ""}
                          />
                        </>
                      ) : (
                        <tr>
                          <td
                            colSpan="4"
                            className="p-6 text-center text-lg font-semibold text-white"
                          >
                            <div className="flex flex-col items-center gap-3 text-center">
                              <FaRegSmile
                                size={28}
                                className="text-green-300"
                              />
                              Get the Best Price! Select Your Services
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {total > 0 && (
                  <>
                    <h2 className="text-md text-white text-left font-medium mt-6 mb-4">
                      Please choose the plan that suits you best
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                      {options.map((option) => (
                        <div
                          key={option.label}
                          onClick={() => handleSelect(option)}
                          className={`cursor-pointer py-2 rounded-md border text-sm transition-all text-center ${
                            selectedOption?.label === option.label
                              ? "bg-gradient-to-r from-[#00DE6D] to-[#00ACDC] text-white"
                              : "bg-white text-gray-700 border-gray-300"
                          }`}
                        >
                          {option.label} {option.discount}% Discount
                        </div>
                      ))}
                    </div>
                    <div className="mt-4 flex flex-col justify-end">
  {selectedOption && ( // Check if a discount option is selected
    <>
      <div className="overflow-x-auto">
        <table className="min-w-full text-end">
          <tbody>
            <tr className="border-t-2 border-gray-400 font-medium text-md text-white">
              <td className="p-4">{selectedOption.label}</td>
              <td className="p-4"></td>
              <td className="p-4">
                ₹{valueAmount || valueTwoAmount || valueThreeAmount || "N/A"}
              </td>
            </tr>
            <tr className="border-t-2 border-gray-400 font-medium text-md text-white">
              <td className="p-4">{selectedOption.label} Discount</td>
              <td className="p-4"></td>
              <td className="p-4">
                ₹{savingsAmount.toFixed(2)}
              </td>
            </tr>
            <tr className="border-t-2 border-gray-400 font-medium text-md text-white">
              <td className="p-4">Total</td>
              <td className="p-4"></td>
              <td className="p-4">
                ₹{(calculateDiscountedPrice() - ((calculateDiscountedPrice() / 1.18) * (9 / 100) * 2)).toFixed(2)}
              </td>
            </tr>
            <tr className="border-t-2 border-gray-400 font-medium text-md text-white">
              <td className="p-4">IGST (18%)</td>
              <td className="p-4"></td>
              <td className="p-4">
                ----
              </td>
            </tr>
            <tr className="border-t-2 border-gray-400 font-medium text-md text-white">
              <td className="p-4">CGST (9%)</td>
              <td className="p-4"></td>
              <td className="p-4">
                ₹{(calculateDiscountedPrice() / 1.18 * (9 / 100)).toFixed(2)}
              </td>
            </tr>
            <tr className="border-t-2 border-gray-400 font-medium text-md text-white">
              <td className="p-4">SGST (9%)</td>
              <td className="p-4"></td>
              <td className="p-4">
                ₹{(calculateDiscountedPrice() / 1.18 * (9 / 100)).toFixed(2)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  )}
</div>


                    {isLoading ? (
                      <>
                        <Loader />
                      </>     
                    ) : (
                      <button
                      onClick={handleBuyNow}
                      className="mt-6 bg-gradient-to-r from-[#00DE6D] to-[#00ACDC] text-white font-bold text-lg py-2 w-full rounded-xl shadow-lg transition-all hover:scale-105 hover:shadow-xl"
                    >
                      Buy Now
                      <span className={`${selectedOption ? "" : "hidden"} `}>
                        - ₹{" "}
                        {calculateDiscountedPrice().toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                        })}
                      </span>
                    </button>
                    )}

                    <button
                      className="text-green-300 mt-4 font-medium underline text-sm"
                      onClick={() => setIsOpen(true)}
                    >
                      Read Terms And Conditions before Purchasing Products
                    </button>
                  </>
                )}

{isOpen && (
  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 p-4">
    <div className="bg-gradient-to-br from-[#202020] via-[#181818] to-[#191919] p-6 rounded-lg shadow-xl border border-gray-300 max-w-lg w-full relative">
      <button
        className="absolute top-2 right-2 text-white"
        onClick={() => setIsOpen(false)}
      >
        <X size={20} />
      </button>
      <h2 className="text-lg font-semibold mb-4 text-center text-white">
        Terms & Conditions
      </h2>
      <ul className="text-sm text-left text-white space-y-3 list-disc list-inside">
        <li>
          <strong>Duration & Renewal:</strong> Minimum commitment of [3/6/12] months. Services auto-renew unless canceled 30 days in advance.
        </li>
        <li>
          <strong>Client Responsibilities:</strong> Provide necessary content, images, and access details on time. Delays may affect project timelines.
        </li>
        <li>
          <strong>Results Disclaimer:</strong> We apply best practices, but rankings, leads, and sales are influenced by various external factors. No guaranteed results.
        </li>
        <li>
          <strong>Content & Copyright:</strong> All content created remains our property unless agreed otherwise. Clients must ensure their provided materials do not infringe copyrights.
        </li>
        <li>
          <strong>Confidentiality:</strong> We respect your business data and do not share it with third parties without consent.
        </li>
        <li>
          <strong>Modifications:</strong> We may update services or terms with prior notice.
        </li>
        <li>
          <strong>Liability:</strong> We are not responsible for indirect losses, penalties, or third-party actions affecting results.
        </li>
      </ul>
    </div>
  </div>
)}
              </div>
              {/* <div className="bg-white bg-opacity-10 backdrop-blur-md shadow-xl p-1 mt-4 rounded-2xl border border-white border-opacity-20 mb-4 text-black">
                <LineChartComponent data={chartData} />
              </div> */}
            </div>
          </div>
        </div>
      <OurClients />
      <Footer />
      </div>
    </>
  );
};
const DiscountDialog = ({ isOpen, onClose, savings,selectedPlan }) => {
  useEffect(() => {
    let timer;
    if (isOpen) {
      // Set a timeout to close the dialog after 5 seconds
      timer = setTimeout(() => {
        onClose();
      }, 5000); // 5000 milliseconds = 5 seconds
    }

    // Cleanup function to clear the timeout if the dialog is closed
    return () => {
      clearTimeout(timer);
    };
  }, [isOpen, onClose]);
  return (
    isOpen && (
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
        <div className="bg-gradient-to-br from-[#202020] via-[#181818] to-[#191919] p-6 rounded-lg shadow-xl border border-gray-600 max-w-md w-full relative text-white">
          {/* Close Button */}
          <button
            className="absolute top-3 right-3 text-white hover:text-gray-300"
            onClick={onClose}
          >
            <X size={24} />
          </button>

          {/* Heading with Party Icon */}
          <div className="text-center mt-2">
            <h2 className="text-xl font-bold flex items-center justify-center gap-2">
              Congratulations! <PartyPopper size={24} />
            </h2>
            <p className="text-sm mt-2">
              By selecting the{" "}
              <span className="font-semibold">{selectedPlan}</span>, you save
              <span className="text-green-400 font-bold">
                {" "}
                ₹{savings.toFixed(2)}!
              </span>
            </p>
          </div>
        </div>
      </div>
    )
  );
};

// In your main return statement

const QuantitySelector = ({ quantity, onChange, min, max }) => (
  <div className="flex items-center justify-center space-x-2 mt-2">
    <button
      onClick={() => onChange(quantity - 1)}
      disabled={quantity <= min}
      className="bg-gradient-to-r from-[#00DE6D] to-[#00ACDC] text-white rounded-full p-2"
    >
      <AiOutlineMinus size={18} />
    </button>
    <input
      type="number"
      value={quantity}
      onChange={(e) => onChange(parseInt(e.target.value) || min)}
      className="w-12 text-center text-black bg-white rounded-md shadow-md"
      min={min}
      max={max}
    />
    <button
      onClick={() => onChange(quantity + 1)}
      disabled={quantity >= max}
      className="bg-gradient-to-r from-[#00DE6D] to-[#00ACDC] text-white rounded-full p-2"
    >
      <AiOutlinePlus size={18} />
    </button>
    <input
      type="range"
      value={quantity}
      onChange={(e) => onChange(parseInt(e.target.value))}
      min={min}
      max={max}
      className="w-full"
    />
  </div>
);

const DurationSelector = ({ selected, onSelect }) => {
  const options = ["15s", "30s", "60s"];
  return (
    <div className="w-full max-w-sm mt-2">
      <h1 className="text-lg mb-2">Video Duration</h1>
      <div className="flex gap-2 justify-start">
        {options.map((option) => (
          <div
            key={option}
            onClick={() => onSelect(option)}
            className={`cursor-pointer capitalize px-4 py-1 rounded-full border text-md transition-all ${
              selected === option
                ? "bg-gradient-to-r from-[#00DE6D] to-[#00ACDC] text-white"
                : "bg-white text-gray-700 border-gray-300"
            }`}
          >
            {option}
          </div>
        ))}
      </div>
    </div>
  );
};

const SocialMediaSelector = ({ selected, onSelect }) => {
  const platforms = [
    { name: "Facebook", icon: <FaFacebook /> },
    { name: "Instagram", icon: <FaInstagram /> },
    { name: "Twitter", icon: <FaXTwitter /> },
    { name: "Threads", icon: <SiThreads /> },
    { name: "WhatsApp channel", icon: <FaWhatsapp /> },
    { name: "Pinterest", icon: <FaPinterest /> },
    { name: "Google Business", icon: <FaGoogle /> },
    { name: "YouTube", icon: <FaYoutube /> },
  ];

  return (
    <div className=" grid sm:grid-cols-1 md:grid-cols-2  gap-2 justify-start w-full p-4">
      {platforms.map(({ name, icon }) => (
        <button
          key={name}
          onClick={() => onSelect(name)}
          className={`flex items-center text-nowrap space-x-2 px-6 py-3 rounded-lg transition-all shadow-md ${
            selected.includes(name)
              ? "bg-gradient-to-r from-[#00DE6D] to-[#00ACDC] text-white"
              : "bg-white text-gray-700 border-gray-300 hover:bg-gradient-to-r from-[#00DE6D] to-[#00ACDC]"
          }`}
        >
          {icon} <span>{name}</span>
        </button>
      ))}
    </div>
  );
};

const PricingRow = ({ label, quantity, cost, onRemove }) => (
  <tr>
    <td className="p-2">{label}</td>
    <td className="p-2">{quantity}</td>
    <td className="p-2">₹{cost.toFixed(2)}</td>
    <td className="p-2">
      <button onClick={onRemove} className="text-red-500 hover:text-red-700">
        <AiOutlineDelete />
      </button>
    </td>
  </tr>
);
export default Home;
